import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Copy, Check, Instagram, Facebook } from "lucide-react";

const COPY = {
  igCaption: `New audio essay on the blog. 💛

The pillow hears my screams. I am overwhelmed.
How do I get back home to myself?

That was the morning I stopped looking outside myself for the answer.

I built a 60-second daily HYGIENE:
Tap-In. Ground. Say hello to my Divine Team. Say thank you. Return.

It rewired my mornings — and brought me home to me.

The full 9-minute audio essay + free printable Yes. No. Wait. cards are waiting for you on the blog.

🔗 Link in bio → "The Tap-In"

— Temple

#mindbodyspirithygiene #igetto #morninghygiene #spiritualhygiene #consciouswomen #realtoolsforrealwomen #messymiddle #divineteam #templefranklin #morningroutine #selflove #innerguidance #mindfulness #mindsethealing #boundaries #selfcare #anxietyrelief #intentionalliving`,

  igStory: `New audio essay 💛
"The HYGIENE That Reclaimed My Life."

9 minutes. Real voice.
Tap-In. Ground. Say hello. Say thank you.

Link → "The Tap-In"`,

  fbCaption: `I just published a new audio essay — and it's the most personal thing I've made.

"The HYGIENE That Reclaimed My Life."

Some mornings the pillow hears my screams and wipes my tears. I am overwhelmed. And someone always needs something from me. How do I get back home to myself?

That was the morning I stopped looking outside myself for the answer. I built a 60-second daily HYGIENE — Tap-In. Ground. Say hello to my Divine Team. Say thank you. Return — and it rewired my mornings.

It's free. 9 minutes. Real voice.

I also tucked a free printable Yes. No. Wait. card deck inside, for the moments when you cannot hear clearly.

Listen here → https://mindbodyspirithygienetools.com/blog/the-tap-in

With love,
Temple 💛`,

  link: "https://mindbodyspirithygienetools.com/blog/the-tap-in",

  hashtags:
    "#mindbodyspirithygiene #igetto #morninghygiene #spiritualhygiene #consciouswomen #realtoolsforrealwomen #messymiddle #divineteam #templefranklin #morningroutine",
};

const CopyBtn = ({ value, label, testId }) => {
  const [copied, setCopied] = useState(false);
  const handle = async () => {
    await navigator.clipboard.writeText(value);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  return (
    <button
      onClick={handle}
      className="inline-flex items-center gap-1.5 bg-[#25a1c2] hover:bg-[#068fa2] text-white text-xs font-bold rounded-full px-4 py-2 transition-all"
      data-testid={testId}
    >
      {copied ? <Check className="w-3.5 h-3.5" /> : <Copy className="w-3.5 h-3.5" />}
      {copied ? "Copied!" : label}
    </button>
  );
};

// Square Instagram post (1:1)
const SquareIGPost = () => (
  <div
    id="ig-square"
    data-testid="ig-square-image"
    className="w-full aspect-square relative overflow-hidden rounded-2xl shadow-2xl"
    style={{
      background: "linear-gradient(135deg, #042F2E 0%, #25a1c2 50%, #068fa2 100%)",
    }}
  >
    <div className="absolute -top-20 -right-20 w-64 h-64 bg-[#5EEAD4]/20 rounded-full blur-3xl"></div>
    <div className="absolute -bottom-32 -left-20 w-72 h-72 bg-[#CCFBF1]/15 rounded-full blur-3xl"></div>
    <div className="relative h-full flex flex-col justify-between p-8 md:p-10 text-white">
      <div className="flex items-center justify-between">
        <p className="font-sans text-[10px] tracking-[0.3em] uppercase text-[#5EEAD4] font-bold">
          Mind Body Spirit HYGIENE™
        </p>
        <p className="font-sans text-[10px] tracking-[0.2em] uppercase text-white/60">
          New essay
        </p>
      </div>
      <div className="text-center">
        <p className="font-sans text-[11px] tracking-[0.25em] uppercase text-[#5EEAD4] font-bold mb-3">
          Free 9-Min Audio
        </p>
        <h1 className="font-serif text-3xl md:text-4xl leading-[1.05] tracking-tight mb-4">
          The HYGIENE That Reclaimed My Life.
        </h1>
        <div className="w-12 h-[2px] bg-[#5EEAD4] mx-auto mb-4"></div>
        <p className="font-serif italic text-base md:text-lg text-[#CCFBF1] leading-snug">
          Tap-In. Ground.
          <br />
          Say Hello. Say Thank You.
        </p>
      </div>
      <div className="text-center">
        <div className="inline-block bg-[#5EEAD4] text-[#042F2E] font-bold text-[10px] tracking-wider uppercase px-4 py-2 rounded-full mb-2">
          Link in Bio
        </div>
        <p className="font-sans text-xs text-white/70">@mindbodyspirithygienetools</p>
      </div>
    </div>
  </div>
);

// 9:16 Story
const StoryIGPost = () => (
  <div
    id="ig-story"
    data-testid="ig-story-image"
    className="w-full aspect-[9/16] relative overflow-hidden rounded-2xl shadow-2xl"
    style={{
      background: "linear-gradient(180deg, #042F2E 0%, #25a1c2 60%, #068fa2 100%)",
    }}
  >
    <div className="absolute top-1/4 -right-10 w-48 h-48 bg-[#5EEAD4]/20 rounded-full blur-3xl"></div>
    <div className="absolute bottom-1/4 -left-10 w-56 h-56 bg-[#CCFBF1]/15 rounded-full blur-3xl"></div>
    <div className="relative h-full flex flex-col justify-between p-6 text-white">
      <div className="text-center pt-6">
        <p className="font-sans text-[9px] tracking-[0.3em] uppercase text-[#5EEAD4] font-bold mb-2">
          Mind Body Spirit HYGIENE™
        </p>
        <p className="font-serif italic text-[#CCFBF1] text-xs">
          A whole new way of living.
        </p>
      </div>
      <div className="text-center">
        <p className="font-sans text-[10px] tracking-[0.3em] uppercase text-[#5EEAD4] font-bold mb-3">
          New Audio Essay
        </p>
        <h1 className="font-serif text-2xl leading-[1.05] tracking-tight mb-4">
          The HYGIENE That Reclaimed My Life.
        </h1>
        <div className="w-10 h-[2px] bg-[#5EEAD4] mx-auto mb-3"></div>
        <p className="font-serif italic text-sm text-[#CCFBF1] leading-snug mb-3">
          Tap-In. Ground.
          <br />
          Say Hello. Say Thank You.
        </p>
        <p className="font-sans text-[11px] text-white/70 leading-relaxed px-2">
          A 60-second daily practice that brought me home to myself.
        </p>
      </div>
      <div className="text-center pb-6">
        <div className="inline-block bg-[#5EEAD4] text-[#042F2E] font-bold text-[10px] tracking-wider uppercase px-4 py-2 rounded-full mb-2">
          Swipe Up · Link Above
        </div>
        <p className="font-sans text-[10px] text-white/70">9 min · Real voice</p>
      </div>
    </div>
  </div>
);

export default function PostTapIn() {
  useEffect(() => {
    document.title = "Instagram & Facebook Pack — The Tap-In | Temple Franklin";
    const robotsTag = document.querySelector('meta[name="robots"]') || (() => {
      const m = document.createElement("meta");
      m.setAttribute("name", "robots");
      document.head.appendChild(m);
      return m;
    })();
    const prevRobots = robotsTag.getAttribute("content");
    robotsTag.setAttribute("content", "noindex, nofollow");
    return () => { robotsTag.setAttribute("content", prevRobots || "index, follow"); };
  }, []);

  return (
    <div className="bg-[#efeae7] min-h-screen pb-16" data-testid="post-tap-in-page">
      <header className="fixed top-0 w-full z-50 bg-white/95 backdrop-blur-xl border-b border-[#CCFBF1] print:hidden">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="text-[#25a1c2] hover:text-[#042F2E] text-sm font-medium inline-flex items-center gap-1.5">
            <ArrowLeft className="w-4 h-4" /> Home
          </Link>
          <span className="text-[10px] font-bold uppercase tracking-widest text-[#25a1c2] bg-[#F0F5F4] px-2.5 py-1 rounded-full">
            Social Pack · Private
          </span>
        </div>
      </header>

      <div className="pt-28 px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10">
            <p className="font-sans text-[10px] tracking-[0.3em] uppercase text-[#25a1c2] font-bold mb-3">
              The Tap-In · Social Media Pack
            </p>
            <h1 className="font-serif text-4xl md:text-5xl tracking-tight text-[#042F2E] mb-3">
              Instagram & Facebook, Ready to Post
            </h1>
            <p className="text-[#475569] max-w-xl mx-auto">
              Right-click any image → Save. Tap each "Copy" button → paste into the matching field.
            </p>
          </div>

          {/* INSTAGRAM SQUARE POST */}
          <section className="mb-16" data-testid="section-ig-square">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#FEDA75] via-[#FA7E1E] via-[#D62976] via-[#962FBF] to-[#4F5BD5] flex items-center justify-center">
                <Instagram className="w-5 h-5 text-white" />
              </div>
              <div>
                <h2 className="font-serif text-2xl text-[#042F2E]">Instagram Feed Post</h2>
                <p className="text-xs text-[#475569]">Square 1:1 · Goes in your main grid</p>
              </div>
            </div>

            <div className="grid md:grid-cols-2 gap-8">
              <div>
                <p className="font-sans text-[10px] tracking-[0.3em] uppercase text-[#25a1c2] font-bold mb-3">
                  Step 1 · Right-click → Save Image
                </p>
                <div className="max-w-[420px]">
                  <SquareIGPost />
                </div>
              </div>

              <div className="space-y-5">
                <div>
                  <p className="font-sans text-[10px] tracking-[0.3em] uppercase text-[#25a1c2] font-bold mb-2">
                    Step 2 · Copy Caption
                  </p>
                  <div className="bg-white border border-[#CCFBF1] rounded-2xl p-5">
                    <div className="flex items-center justify-between mb-3">
                      <h3 className="font-sans text-xs font-bold uppercase tracking-widest text-[#25a1c2]">
                        Caption + Hashtags
                      </h3>
                      <CopyBtn value={COPY.igCaption} label="Copy Caption" testId="copy-ig-caption" />
                    </div>
                    <p
                      className="text-[#042F2E] text-xs leading-relaxed whitespace-pre-line max-h-72 overflow-y-auto"
                      data-testid="ig-caption-text"
                    >
                      {COPY.igCaption}
                    </p>
                  </div>
                </div>

                <div className="bg-amber-50 border border-amber-200 rounded-2xl p-4 text-sm text-amber-900">
                  <p className="font-bold mb-1">📲 Quick steps in Instagram:</p>
                  <ol className="list-decimal list-inside space-y-1 text-xs">
                    <li>Save the square image to your Camera Roll</li>
                    <li>Open Instagram → "+" → Post</li>
                    <li>Pick the saved image</li>
                    <li>Paste the caption</li>
                    <li>Share — make sure your bio link points to the blog</li>
                  </ol>
                </div>
              </div>
            </div>
          </section>

          {/* INSTAGRAM STORY */}
          <section className="mb-16" data-testid="section-ig-story">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#FA7E1E] via-[#D62976] to-[#962FBF] flex items-center justify-center">
                <Instagram className="w-5 h-5 text-white" />
              </div>
              <div>
                <h2 className="font-serif text-2xl text-[#042F2E]">Instagram Story</h2>
                <p className="text-xs text-[#475569]">Vertical 9:16 · Add a Link Sticker</p>
              </div>
            </div>

            <div className="grid md:grid-cols-2 gap-8">
              <div>
                <p className="font-sans text-[10px] tracking-[0.3em] uppercase text-[#25a1c2] font-bold mb-3">
                  Step 1 · Right-click → Save Image
                </p>
                <div className="max-w-[280px]">
                  <StoryIGPost />
                </div>
              </div>

              <div className="space-y-5">
                <div>
                  <p className="font-sans text-[10px] tracking-[0.3em] uppercase text-[#25a1c2] font-bold mb-2">
                    Step 2 · Add Link Sticker
                  </p>
                  <div className="bg-white border border-[#CCFBF1] rounded-2xl p-5">
                    <div className="flex items-center justify-between mb-3">
                      <h3 className="font-sans text-xs font-bold uppercase tracking-widest text-[#25a1c2]">
                        Link Sticker URL
                      </h3>
                      <CopyBtn value={COPY.link} label="Copy Link" testId="copy-story-link" />
                    </div>
                    <p className="text-[#25a1c2] text-xs font-mono break-all">{COPY.link}</p>
                  </div>
                </div>

                <div>
                  <p className="font-sans text-[10px] tracking-[0.3em] uppercase text-[#25a1c2] font-bold mb-2">
                    Optional · Story Text Overlay
                  </p>
                  <div className="bg-white border border-[#CCFBF1] rounded-2xl p-5">
                    <div className="flex items-center justify-between mb-3">
                      <h3 className="font-sans text-xs font-bold uppercase tracking-widest text-[#25a1c2]">
                        Caption for Story
                      </h3>
                      <CopyBtn value={COPY.igStory} label="Copy" testId="copy-ig-story-text" />
                    </div>
                    <p className="text-[#042F2E] text-xs leading-relaxed whitespace-pre-line">
                      {COPY.igStory}
                    </p>
                  </div>
                </div>

                <div className="bg-amber-50 border border-amber-200 rounded-2xl p-4 text-sm text-amber-900">
                  <p className="font-bold mb-1">📲 Quick steps in Instagram Story:</p>
                  <ol className="list-decimal list-inside space-y-1 text-xs">
                    <li>Save the vertical image to your Camera Roll</li>
                    <li>Open Instagram → Your Story → Pick the saved image</li>
                    <li>Tap the sticker icon → "Link" → Paste the URL above</li>
                    <li>Position the link sticker over the "Swipe Up" button</li>
                    <li>Tap "Your Story" — share!</li>
                  </ol>
                </div>
              </div>
            </div>
          </section>

          {/* FACEBOOK */}
          <section className="mb-12" data-testid="section-fb">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 rounded-full bg-[#1877F2] flex items-center justify-center">
                <Facebook className="w-5 h-5 text-white" />
              </div>
              <div>
                <h2 className="font-serif text-2xl text-[#042F2E]">Facebook Post</h2>
                <p className="text-xs text-[#475569]">Reuse the IG square image · Different caption</p>
              </div>
            </div>

            <div className="bg-white border border-[#CCFBF1] rounded-2xl p-6">
              <div className="flex items-center justify-between mb-4">
                <h3 className="font-sans text-xs font-bold uppercase tracking-widest text-[#25a1c2]">
                  Facebook Caption
                </h3>
                <CopyBtn value={COPY.fbCaption} label="Copy FB Caption" testId="copy-fb-caption" />
              </div>
              <p
                className="text-[#042F2E] text-sm leading-relaxed whitespace-pre-line"
                data-testid="fb-caption-text"
              >
                {COPY.fbCaption}
              </p>
            </div>
          </section>

          {/* MASTER LINK */}
          <section className="bg-gradient-to-br from-[#042F2E] to-[#068fa2] rounded-2xl p-8 text-center text-white">
            <p className="font-sans text-[10px] tracking-[0.3em] uppercase text-[#5EEAD4] font-bold mb-2">
              The Master Link
            </p>
            <p className="font-serif text-2xl mb-4">Bio · Story Sticker · Caption Link</p>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 inline-block">
              <p className="font-mono text-sm text-[#5EEAD4] break-all">{COPY.link}</p>
            </div>
            <div className="mt-4">
              <CopyBtn value={COPY.link} label="Copy Master Link" testId="copy-master-link" />
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
